import { compose } from 'react-apollo';
import { HelpCenterSettingsView } from './help-center-settings.component';
import { withSettings, withUpdateSettings } from './settings.container';

export const HelpCenterSettings = compose(withSettings, withUpdateSettings)(HelpCenterSettingsView);
